import { createI18n } from "vue-i18n";

const messages = {
  ko: {
    attachments: "첨부 파일",
    device_model: "기기 모델",
    email_address: "이메일 주소",
    hospital_name: "병원 이름",
    inquiry: "문의하기",
    item: "아이템",
    lot: "로트",
    message: "메시지",
    model: "모델",
    name: "이름",
    no_data: "데이터 없음",
    phone_number: "휴대폰 번호",
    quantitative_results: "정량 결과",
    qualitative_results: "정성 결과",
    required: "필수",
    restart: "다시하기",
    select: "선택하기",
    serial_number: "시리얼 번호",
    successfully_sent: "성공적으로 전송되었습니다!",
    test_date: "검사 일시",
    test_error: "검사 오류",
    unregistered: "미등록",
    username: "사용자 이름",
    version: "버전",
    view_details: "상세 보기",
    _inquiry: {
      send: "문의 내용 전송"
    },
    test: {
      add_media: "미디어 추가",
      details: "검사 상세 정보",
      download_raw_data: "Raw Data 다운로드",
      message_placeholder: "전달하고 싶은 메시지를 입력하세요.",
      privacy_consent: "개인정보 수집 및 이용에 동의합니다.",
      scan_qr_code: "다음 QR 코드를 스캔해 주세요.",
      send: "결과 보고서 전송",
      submit_inquiry: "문의하기",
      review: {
        result_report: "검사 결과 보고서",
        results: "검사 결과",
        message: "담당자 확인 요청 메시지"
      }
    }
  },
  en: {
    attachments: "Attachments",
    device_model: "Device Model",
    email_address: "Email Address",
    hospital_name: "Hospital Name",
    inquiry: "Inquiry",
    item: "Item",
    lot: "Lot",
    message: "Message",
    model: "Model",
    name: "Name",
    no_data: "No Data",
    phone_number: "Phone Number",
    quantitative_results: "Quantitative Results",
    qualitative_results: "Qualitative Results",
    restart: "Restart",
    required: "Required",
    select: "Select",
    serial_number: "Serial Number",
    successfully_sent: "Successfully sent!",
    test_date: "Test Date",
    test_error: "Test Error",
    unregistered: "Unregistered",
    username: "Username",
    version: "Version",
    view_details: "View Details",
    _inquiry: {
      send: "Submit Inquiry"
    },
    test: {
      add_media: "Add Media",
      details: "Test Details",
      download_raw_data: "Download Raw Data",
      message_placeholder: "Enter the message you want to convey.",
      privacy_consent:
        "I agree to the collection and use of personal information.",
      scan_qr_code: "Please scan the next QR code.",
      send: "Send Test Report",
      submit_inquiry: "Submit Inquiry",
      review: {
        result_report: "Test Result Report",
        results: "Test Results",
        message: "Message to Request Staff Review"
      }
    }
  }
};

export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem("user-locale") || "en",
  fallbackLocale: "en",
  messages
});
